import {Container, ContainerModule, type interfaces} from "inversify";
import {Bindings} from "data/constants/bindings";

import {JSON_URL} from "data/constants";
import {type IJSONProvider, JSONProvider} from "data/providers/json/json.provider";
import {HttpClientFactory, type IHttpClientService} from "data/services/http";
import {RoundsStore, type IRoundsStore} from "data/stores/rounds/rounds.store";
import {SquadsStore, type ISquadsStore} from "data/stores/squads/squds.store";

import {
	IWidgetLoaderController,
	WidgetLoaderController,
} from "views/components/widget_loader/widget_loader.controller";
import {
	ISquadImageController,
	SquadImageController,
} from "views/components/squad_image/squad_image.controller";
import {WidgetController, IWidgetController} from "views/pages/widget/widget.controller";
import {IFiltersController, FiltersController} from "views/components/filters/filters.controller";
import {
	IMatchCardController,
	MatchCardController,
} from "views/components/match_card/match_card.controller";
import {
	MatchStatusController,
	IMatchStatusController,
} from "views/components/match_status/match_status.controller";
import {
	IHOCLiveScoreController,
	HOCLiveScoreController,
} from "views/components/hoc_live_score/hoc_live_score.controller";
import {ChecksumsStore, IChecksumsStore} from "data/stores/checksums/checksums.store";
import {ILocalizationStore, LocalizationStore} from "data/stores/localization/localization.store";
import {
	LocalizationController,
	ILocalizationController,
} from "views/controllers/localization/localization.controller";
import {
	IBootstrapController,
	BootstrapController,
} from "views/components/bootstrap/bootstrap.controller";

export const DIContainer = new Container();

export const services = new ContainerModule((bind: interfaces.Bind) => {
	bind<IHttpClientService>(Bindings.JsonHTTPClient).toConstantValue(
		HttpClientFactory.createJSONClient({
			baseURL: JSON_URL,
		})
	);
});

export const providers = new ContainerModule((bind: interfaces.Bind) => {
	bind<IJSONProvider>(Bindings.JSONProvider).to(JSONProvider);
});

export const stores = new ContainerModule((bind: interfaces.Bind) => {
	bind<IRoundsStore>(Bindings.RoundsStore).to(RoundsStore).inSingletonScope();
	bind<ISquadsStore>(Bindings.SquadsStore).to(SquadsStore).inSingletonScope();
	bind<IChecksumsStore>(Bindings.ChecksumsStore).to(ChecksumsStore).inSingletonScope();
	bind<ILocalizationStore>(Bindings.LocalizationStore).to(LocalizationStore).inSingletonScope();
});

export const controllers = new ContainerModule((bind: interfaces.Bind) => {
	bind<IWidgetLoaderController>(Bindings.WidgetLoaderController).to(WidgetLoaderController);
	bind<IBootstrapController>(Bindings.BootstrapController).to(BootstrapController);
	bind<IHOCLiveScoreController>(Bindings.HOCLiveScoreController).to(HOCLiveScoreController);
	bind<ISquadImageController>(Bindings.SquadImageController).to(SquadImageController);
	bind<IWidgetController>(Bindings.WidgetController).to(WidgetController);
	bind<IFiltersController>(Bindings.FiltersController).to(FiltersController);
	bind<IMatchCardController>(Bindings.MatchCardController).to(MatchCardController);
	bind<IMatchStatusController>(Bindings.MatchStatusController).to(MatchStatusController);
	bind<ILocalizationController>(Bindings.LocalizationController).to(LocalizationController);
});
